"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserStatus = void 0;
var UserStatus;
(function (UserStatus) {
  UserStatus["UNKNOWN"] = "UNKNOWN";
  UserStatus["ENABLED"] = "ENABLED";
  UserStatus["ARCHIVED"] = "ARCHIVED";
  UserStatus["INVITED"] = "INVITED";
})(UserStatus = exports.UserStatus || (exports.UserStatus = {}));